import * as React from 'react';
export var useLayoutEffect = typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
    ? React.useLayoutEffect
    : React.useEffect;
